import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import { createBidProposal, downloadFile } from '../../api/constlink';
import BidChanceDetailComponent from '../../components/bid-chances/BidChanceDetailComponent';
import { RootState } from '../../modules';
import {
  BidChance,
  BidProposalParams,
  getBidChanceDetailAsync,
  updateBidChanceAsync,
} from '../../modules/bid-chances';
import {
  getBidChanceSharedFileAPIPath,
  getBidProposalFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';
import qs from 'qs';
import BidProposalCreateModal from '../../components/bid-chances/BidProposalCreateModal';
interface BidChance2DetailContainerProps {
  bidChanceId: string;
}
function BidChance2DetailContainer({
  match,
  history,
}: RouteComponentProps<BidChance2DetailContainerProps>) {
  // const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const { bidChanceId } = match.params;
  const { token } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const { data, loading, error } = useSelector(
    (state: RootState) => state.bidChances.bidChance,
  );
  const dispatch = useDispatch();
  const [coords, setCoords] = useState<any>();
  const [uploadProps, setUploadProps] = useState<any>();
  // const [userData, setUserData] = useState<any>({
  //   name: '홍영기',
  //   personalPhone: '01051629415',
  // });
  // const [authCode, setAuthCode] = useState<any>(null);
  // const [verifiedAuthCode, setVerifiedAuthCode] = useState<any>(null);

  useEffect(() => {
    dispatch(getBidChanceDetailAsync.request({ bidChanceId, token }));
  }, [dispatch, bidChanceId, token]);

  useEffect(() => {
    const geocoder = new kakao.maps.services.Geocoder();
    if (data === null) return;
    if (data?.bidder?.bidPackage?.project?.location === undefined) return;
    geocoder.addressSearch(
      data.bidder.bidPackage.project.location,
      function (result: any[], status: any) {
        if (status === kakao.maps.services.Status.OK) {
          setCoords({ lat: result[0].y, lng: result[0].x });
        } else {
          setCoords({});
        }
      },
    );
  }, [data]);

  useEffect(() => {
    (async () => {
      setUploadProps(
        await initializeUploadProps(getBidProposalFileAPIPath(bidChanceId)),
      );
    })();
  }, [bidChanceId]);

  // const onCreate = (value: any) => {
  //   dispatch(
  //     updateBidChanceAsync.request({
  //       bidChance: {
  //         id: +bidChanceId,
  //         status: value.status,
  //       } as BidChance,
  //     }),
  //   );
  //   setVisible(false);
  // };

  // const onCancel = () => {
  //   setVisible(false);
  // };

  // const openUpdateBidChanceStatusModal = () => {
  //   setVisible(true);
  // };

  const changeBidStatus = (status: any) => {
    dispatch(
      updateBidChanceAsync.request({
        bidChance: {
          id: +bidChanceId,
          status,
        } as BidChance,
      }),
    );
  };

  const moveToCreateBidProposalPage = () => {
    // history.push(`${bidChanceId}/bidProposals/create`);
    setVisible1(true);
  };

  const closeBidProposalCreateModal = () => setVisible1(false);
  const submitBidProposal = async (data: any) => {
    const bidProposalParams: BidProposalParams = {
      bidChanceId,
      bidProposal: {
        ...data,
        bidProposalLineItems: [],
      },
    };
    if (bidProposalParams.bidProposal?.file) {
      for (const _file of bidProposalParams.bidProposal.file) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    // dispatch(createBidProposalAsync.request(bidProposalParams));
    try {
      await createBidProposal(bidProposalParams);
      history.push(`/bid-proposal-submit-result?result=success`);
    } catch (error: any) {
      history.push(`/bid-proposal-submit-result?result=fail`);
    }
  };

  // const moveToBidProposalDetailPage = (bidProposalId: number) => {
  //   history.push(`${bidChanceId}/bidProposals/${bidProposalId}/detail`);
  // };

  const _downloadFile = async (attachFileId: string, fileName: string) => {
    await downloadFile(
      getBidChanceSharedFileAPIPath(bidChanceId),
      attachFileId,
      fileName,
    );
  };

  // const _requestAuthCode = async (data: any) => {
  //   console.log(data);
  //   try {
  //     await requestAuthCode({ data });
  //     setAuthCode({ message: '인증코드를 요청하였습니다.', type: 'success' });
  //   } catch (error) {
  //     setAuthCode({
  //       message: '인증코드 요청을 실패 하였습니다.',
  //       type: 'danger',
  //     });
  //   }
  // };

  // const _verifyAuthCode = async (data: any) => {
  //   try {
  //     console.log(data);
  //     const result = await verifyAuthCode({ data });
  //     console.log(result);
  //     setVerifiedAuthCode({
  //       message: '휴대전화 인증 성공 하였습니다.',
  //       type: 'success',
  //     });
  //   } catch (error) {
  //     setVerifiedAuthCode({
  //       message: '휴대전화 인증 실패 하였습니다.',
  //       type: 'danger',
  //     });
  //   }
  // };

  // const updateUserData = (data: any) => {
  //   console.log(data);
  //   setUserData({ ...data });
  // };

  return (
    <Layout style={{ padding: '40px', background: '#fff' }}>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}
      {/* {userData === undefined && (
        <VerifyUserInfo
          authCode={authCode}
          verifiedAuthCode={verifiedAuthCode}
          successBtnMsg={'다음'}
          requestAuthCode={_requestAuthCode}
          verifyAuthCode={_verifyAuthCode}
          updateUserData={updateUserData}
        />
      )} */}
      {data && (
        <BidChanceDetailComponent
          bidChance={data}
          coords={coords}
          moveToCreateBidProposalPage={moveToCreateBidProposalPage}
          downloadFile={_downloadFile}
          changeBidStatus={changeBidStatus}
        />
      )}
      {/* {data && (
        <UpdateBidChanceStatusModal
          bidChance={data}
          visible={visible}
          onCancel={onCancel}
          onCreate={onCreate}
        />
      )} */}
      <BidProposalCreateModal
        visible={visible1}
        uploadProps={uploadProps}
        onFinish={submitBidProposal}
        onCancel={closeBidProposalCreateModal}
      />
    </Layout>
  );
}

export default BidChance2DetailContainer;
